import React, { useState } from "react";

import MobileTopBar from "./MobileTopBar";
import Sidebar, { getInitialSidebarCollapsed, persistSidebarCollapsed } from "./Sidebar";

const AppShell = ({ children, currentUser = null, pageTitle, pageSubtitle }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(getInitialSidebarCollapsed);

  return (
    <div className="min-h-screen bg-theme-main text-theme-text flex">
      <Sidebar
        currentUser={currentUser}
        collapsed={sidebarCollapsed}
        onCollapsedChange={(v) => {
          setSidebarCollapsed(v);
          persistSidebarCollapsed(v);
        }}
        variant="desktop"
      />

      {mobileNavOpen ? (
        <button
          type="button"
          aria-label="Close menu"
          className="md:hidden fixed inset-0 z-40 bg-black/50 backdrop-blur-[1px] transition-opacity"
          onClick={() => setMobileNavOpen(false)}
        />
      ) : null}

      <div
        className={`md:hidden fixed inset-y-0 left-0 z-50 w-[min(18rem,88vw)] max-w-full overflow-visible transform transition-transform duration-300 ease-out shadow-xl ${
          mobileNavOpen ? "translate-x-0" : "-translate-x-full pointer-events-none"
        }`}
      >
        <Sidebar
          currentUser={currentUser}
          collapsed={false}
          onCollapsedChange={() => {}}
          variant="mobile"
          onCloseMobile={() => setMobileNavOpen(false)}
        />
      </div>

      <div className="flex-1 min-w-0 flex flex-col">
        <MobileTopBar title={pageTitle} subtitle={pageSubtitle} onOpenNav={() => setMobileNavOpen(true)} />
        <main className="flex-1 p-4 pt-[4.5rem] md:p-8 md:pt-8">{children}</main>
      </div>
    </div>
  );
};

export default AppShell;
